import { render, staticRenderFns } from "./ClmStatCause.vue?vue&type=template&id=394732a7&"
import script from "./ClmStatCause.vue?vue&type=script&lang=js&"
export * from "./ClmStatCause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports